import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

/**
 * 区域管理API服务
 */
export const areaService = {
  /**
   * 获取区域树形结构
   */
  getAreaTree: () => axios.get(`${iffApi}/area/tree`, { params: { } }),

  /**
   * 保存区域
   * @param {Object} data 区域信息
   */
  addArea: (data) => axios.post(`${iffApi}/area/save`, data),

  updateArea: (data) => axios.post(`${iffApi}/area/update`, data),

  /**
   * 删除区域
   * @param {String} uuid 区域ID
   */
  deleteArea: (uuid) => axios.delete(`${iffApi}/area/delete/${uuid}`),

  /**
   * 批量删除区域
   * @param {Array} uuids 区域ID列表
   */
  batchDeleteArea: (uuids) => axios.post(`${iffApi}/area/batchDelete`, uuids)
};
